
import { defineComponent } from 'vue';
import 'floating-vue/dist/style.css';

export default defineComponent({});
